import { type TFunction } from 'i18next';

// Display order of guided tool names
export const guidedToolsInOrder = [
  'table',
  'keyboard',
  'aria-modal',
  'interactive-elements',
  'structure',
  'page-info', // DEPRECATED!
  'buttons-and-links', // DEPRECATED!
  'lists', // DEPRECATED!
  'images',
  'headings', // DEPRECATED!
  'forms'
] as const;

export type GuidedTool = (typeof guidedToolsInOrder)[number];

export interface GuideConfig {
  name: GuidedTool;
  heading: string;
  deprecated?: boolean;
}

const sortGuides = (a: GuideConfig, b: GuideConfig) => {
  const indexA = guidedToolsInOrder.indexOf(a.name);
  const indexB = guidedToolsInOrder.indexOf(b.name);
  return indexA - indexB;
};

export const getGuides = (t: TFunction): GuideConfig[] => {
  const interactiveElement: GuideConfig = {
    name: 'interactive-elements',
    heading: t('Interactive Elements')
  };

  const structure: GuideConfig = {
    name: 'structure',
    heading: t('Structure')
  };

  const modalDialog: GuideConfig = {
    name: 'aria-modal',
    heading: t('Modal Dialog')
  };

  const table: GuideConfig = {
    name: 'table',
    heading: t('Table')
  };

  const images: GuideConfig = {
    name: 'images',
    heading: t('Images')
  };

  const keyboard: GuideConfig = {
    name: 'keyboard',
    heading: t('Keyboard')
  };

  const forms: GuideConfig = {
    name: 'forms',
    heading: t('Forms')
  };

  const pageInfo: GuideConfig = {
    name: 'page-info',
    heading: t('Page Information'),
    deprecated: true
  };

  const buttonAndLinks: GuideConfig = {
    name: 'buttons-and-links',
    heading: t('Buttons and Links'),
    deprecated: true
  };

  const lists: GuideConfig = {
    name: 'lists',
    heading: t('Lists'),
    deprecated: true
  };

  const headings: GuideConfig = {
    name: 'headings',
    heading: t('Headings'),
    deprecated: true
  };

  return [
    interactiveElement,
    structure,
    modalDialog,
    table,
    images,
    keyboard,
    forms,
    pageInfo,
    buttonAndLinks,
    lists,
    headings
  ].sort(sortGuides);
};

export default getGuides;
